import { FC } from 'react'
import styled from 'styled-components'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import ja from 'date-fns/locale/ja'

import { colorPallet } from '../styles/colors'
import 'react-datepicker/dist/react-datepicker.css'
import { CalenderIcon } from './icons/CalenderIcon'

type DatePickerProps = {
  selected: Date
  onChange: (date: Date) => void
}

export const DatePicker: FC<DatePickerProps> = (props) => {
  const { selected, onChange } = props
  registerLocale('ja', ja)
  return (
    <StyledWrapper>
      <StyledReactDatePicker
        locale="ja"
        selected={selected}
        onChange={onChange}
        popperPlacement="top-end"
        maxDate={new Date()}
        dateFormat="yyyy/M/dd"
      />
      <StyledCalenderIconWrap>
        <CalenderIcon />
      </StyledCalenderIconWrap>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  position: relative;
  display: inline-block;

  .react-datepicker__navigation--next {
    border-left-color: ${colorPallet.primary};
  }
  .react-datepicker__navigation--previous {
    border-right-color: ${colorPallet.primary};
  }
  .react-datepicker__day--selected {
    background-color: ${colorPallet.primary};
  }
  * {
    outline: none;
  }
`

const StyledReactDatePicker = styled(ReactDatePicker)`
  font-size: 16px;
  padding: 10px;
  border-radius: 5px;
  border: 2px solid ${colorPallet.primary};
  color: #6f6f6f;
  position: relative;
  z-index: 10;
  background: transparent;
  cursor: pointer;
`
const StyledCalenderIconWrap = styled.div`
  position: absolute;
  right: 8px;
  top: 7px;
  z-index: 0;
`
